import { numberFormat } from '@/helpers/numbers'
import type { CanteenCartItem } from './types'

export const sumItemOptionsCost = (options: CanteenCartItem['options'] = []) =>
  options.reduce((total, { price }) => total + Number.parseFloat(price || '0'), 0)

export const calcItemTotalCost = (
  price: number | string = 0,
  optionsCost: number | string = 0,
  qty: number | string = 0,
) =>
  (Number.parseFloat(price.toString()) + Number.parseFloat(optionsCost.toString())) *
  Number.parseInt(qty.toString(), 10)

export const calculateCartItemTotal = (cartItem: CanteenCartItem) =>
  Number.parseFloat(
    numberFormat(
      calcItemTotalCost(cartItem.item.price, sumItemOptionsCost(cartItem.options), cartItem.qty),
      2,
      false,
    ),
  )

export const calculateCartTotal = (cartItems: CanteenCartItem[] = []) => {
  const cartTotal = cartItems.reduce(
    (total, cartItem) => total + calculateCartItemTotal(cartItem),
    0,
  )

  return Number.parseFloat(numberFormat(cartTotal, 2, false))
}
